module.exports = __webpack_public_path__ + "img/psstruck-nobg-small-mobile.a34b9de4.png";